<template>
  <div class="qv-head">
    <div class="qv-head-top">
      <div class="qv-title-wrap">
        <div class="qv-title">
          <h3>{{ product && product.name }}</h3>
        </div>
        <div class="qv-updated">
          <span class="sku">{{ product && product.internal_code }}</span>

          <span class="updated-text">
            {{ product && product.store }} · Atualizado em {{ formattedUpdatedAt }}
          </span>
        </div>
      </div>

      <a-dropdown v-if="compactStoreSelect" :trigger="['click']" :disabled="storeLocked">
        <a-button class="qv-store-chip" :disabled="storeLocked">
          <a-icon type="shop" />
          {{ currentStoreLabel }}
          <a-icon v-if="!storeLocked" type="down" />
        </a-button>

        <a-menu slot="overlay" @click="({ key }) => $emit('change-store', key)">
          <a-menu-item
            v-for="store in stores"
            :key="store.id_loja"
          >
            {{ store.loja_descricao.trim() }}
          </a-menu-item>
        </a-menu>
      </a-dropdown>

      <slot name="actions"></slot>
    </div>

    <div class="qv-store-select" v-if="!compactStoreSelect">
      <a-icon type="shop" class="qv-store-icon" />

      <a-select
        :value="selectedStoreId"
        class="qv-store-select-input"
        show-search
        option-filter-prop="children"
        placeholder="Selecione a loja"
        :disabled="storeLocked"
        @change="$emit('change-store', $event)"
      >
        <a-select-option
          v-for="store in stores"
          :key="store.id_loja"
          :value="store.id_loja"
        >
          {{ store.loja_descricao.trim() }}
        </a-select-option>
      </a-select>
    </div>
  </div>
</template>

<script>
export default {
    name: 'QvHeader',

    props: {
        product: {
            type: Object,
            default: null,
        },

        updatedAt: {
            type: String,
            default: '',
        },

        stores: {
            type: Array,
            default: () => [],
        },

        selectedStoreId: {
            type: [String, Number],
            default: null,
        },

        compactStoreSelect: {
            type: Boolean,
            default: false,
        },

        storeLocked: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        currentStoreLabel() {
            const current = this.stores.find(
                (store) => String(store.id_loja) === String(this.selectedStoreId)
            );

            return current ? current.loja_descricao.trim() : 'Selecione a loja';
        },

        formattedUpdatedAt() {
            if (!this.updatedAt) {
                return '';
            }

            const [datePart, timePart] = String(this.updatedAt).split(/[ T]/);
            const [year, month, day] = (datePart || '').split('-');

            if (!year || !month || !day) {
                return this.updatedAt;
            }

            const time = timePart ? timePart.substring(0, 5) : '';

            return `${day}/${month}/${year}${time ? ' ' + time : ''}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import './_qv-shared.scss';

.qv-head {
  padding: 14px 18px;
  border-bottom: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.qv-head-top {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.qv-store-chip.ant-btn,
.qv-store-chip.ant-btn:focus,
.qv-store-chip.ant-btn:active {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  height: 30px;
  padding: 0 10px;
  margin-top: 1px;
  background: var(--bg);
  border: 1px solid var(--border-strong);
  border-radius: 15px;
  color: var(--text);
  font-size: 12px;
  font-weight: 600;
  box-shadow: none;
}

.qv-store-chip.ant-btn:hover {
  border-color: var(--brand-deep);
  color: var(--brand-deep);
}

.qv-store-chip.ant-btn ::v-deep span {
  margin-left: 0;
}

.qv-title-wrap {
  flex: 1;
  min-width: 0;
}

.qv-title h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
}

.qv-updated {
  margin-top: 4px;
  font-size: 10.5px;
  color: var(--text-3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sku {
  font-family: "JetBrains Mono", monospace;
  font-size: 10.5px;
  color: var(--text-3);
  background: var(--bg);
  border: 1px solid var(--border-strong);
  border-radius: 10px;
  padding: 1px 9px;
}

.updated-text {
  margin-left: 8px;
}

.qv-store-select {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: var(--bg);
  border: 1px solid var(--border-strong);
  border-radius: 8px;
}

.qv-store-icon {
  color: var(--text-3);
  font-size: 14px;
  flex-shrink: 0;
}

.qv-store-select-input {
  flex: 1;
  min-width: 0;
}

.qv-store-select-input ::v-deep .ant-select-selection {
  border: none;
  background: transparent;
  box-shadow: none;
}
</style>
